import { FooterType } from "../../social-supermarket/model/FooterType"

export const mapFooter = (footer: any): FooterType => ({
  badges: footer.allWp.nodes[0].options.custom.featuredBadges.map(({ image, url }) => ({
    image: image?.localFile?.childImageSharp
      ? { gatsbyImageData: image?.localFile?.childImageSharp?.gatsbyImageData, alt: url?.title }
      : undefined,
    url: url?.url,
  })),
  infoItems: footer.infoMenu.nodes[0].menuItems.nodes,
  shopItems: footer.shopMenu.nodes[0].menuItems.nodes,
})
